import Vue from "vue";
import _ from "lodash";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import "@/styles/index.scss"; // global css

import App from "./App";
import store from "./store";
import router from "./router";
import "./lib/elementui";
import * as echarts from "echarts"; // 在import的后面，echarts的前面加一个 * as
Vue.prototype.$echarts = echarts;
import "echarts4/map/js/world";
import { numFormat } from "./filters/numberFormat";
import eventBus from "./eventBus.js"; //消息组件
Vue.prototype.$eventBus = eventBus;
import "@/icons"; // icon
import "@/permission"; // permission control

import CheckQuery from "./components/QueryDialog/CheckQuery";
import CreateQuery from "./components/QueryDialog/CreateQuery";

import prem from "./mixins/prem";
//<Footer />注册全局
const Footer = () => import("@/components/Footer");
Vue.component("Footer", Footer);

const FooterHome = () => import("@/components/FooterHome");
Vue.component("FooterHome", FooterHome);
Vue.use(CheckQuery);
Vue.use(CreateQuery);

Vue.filter("numFormat", numFormat);
Vue.mixin(prem);

Vue.config.productionTip = false;
Vue.prototype.$_ = _;

Vue.directive("tableloadmore", {
  bind(el, binding) {
    const selectWrap = el.querySelector(".el-table__body-wrapper");
    selectWrap.addEventListener("scroll", function () {
      let sign = 100;
      const scrollDistance =
        this.scrollHeight - this.scrollTop - this.clientHeight;
      if (scrollDistance <= sign) {
        binding.value();
      }
    });
  },
});
// 创建一个 Vue 实例作为事件总线，并在其中定义全局数据
// const eventBus = new Vue({
//   data() {
//     return {
//       globalData: "global data",
//     };
//   },
// });
store.dispatch("user/getInfo").then((res) => {
  new Vue({
    el: "#app",
    router,
    store,
    data: {
      eventHub: new Vue(),
    },
    render: (h) => h(App),
  });

  //埋点
  router.beforeEach((to, from, next) => {
    try {
      // LogCollection.end();
    } catch (e) {}
    next();
  });

  router.afterEach((to, from) => {
    try {
      // LogCollection.init();
    } catch (e) {}
    if (to.path === "/") {
      document.documentElement.style.fontSize =
        document.documentElement.clientWidth / 1920 + "px";
    } else {
      document.documentElement.style.fontSize = "";
      window.onresize = function () {
        document.documentElement.style.fontSize = "";
      };
    }

    // next();
  });
});
